import React from 'react';
import AGWatchIcon from './AGWatchIcon';

interface AGWatchCellRendererProps {
  data: {
    id: number;
  };
}

const AGWatchCellRenderer: React.FC<AGWatchCellRendererProps> = ({ data }) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <AGWatchIcon certificationId={data.id} />
    </div>
  );
};

// This function is used by AG Grid for filtering and sorting
export const getWatchValue = (_params: unknown): string => {
  // This will be called by AG Grid for filtering and sorting
  // We'll return a placeholder since the actual value comes from the context
  return 'Yes'; // Placeholder for grid operations
};

export default AGWatchCellRenderer;
